import {Directive, OnDestroy, OnInit} from "@angular/core";
import {Appointment, Patient, PatientInfo, User} from "@allaihealth/util";
import {AppointmentsService} from "../../services/appointments.service";
import {Subscription} from "rxjs";
import {Category, TaskController, TaskControllerInstance} from "../../util/task-controller";
import {AppointmentTask} from "intake-shared";
import {PageLoaderService, SnackbarService} from "@allaihealth/ng-platform";
import {HttpClient} from "@angular/common/http";


/**
 * Base component class for patient subpages page. Has some useful listening and retrieval functions that all
 * inheriting classes can use.
 */
@Directive()
export abstract class BasePatientPage implements OnInit, OnDestroy {
	/** Currently selected appointment */
	appointment:Appointment;

	/** Currently selected appointment's patient */
	patient:Patient;

	/** Currently selected appointment's provider */
	provider:User;

	tasks:AppointmentTask;

	patientInfo:PatientInfo;

	constructor(protected pageLoaderService:PageLoaderService,
	            protected snackbarService:SnackbarService,
	            protected http: HttpClient,
	            protected appointmentsService:AppointmentsService) {
	}

	/** Subscription for appointment changes */
	private subscription:Subscription;
	protected taskValues:{ [key:string]:boolean };

	ngOnInit():void {
		//monitor for changes in the route
		this.subscription = this.appointmentsService.onNewAppointment.subscribe(async appointment => {
			this.appointment = appointment;
			this.patient = this.appointmentsService.patient;
			this.provider = this.appointmentsService.provider;
			this.tasks = this.appointmentsService.tasks;
			this.taskValues = this.appointmentsService.taskValues;
			this.patientInfo = this.appointmentsService.patientInfo;
		});
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

	async setValue(taskKey:string, valueKey:string, $event:boolean) {
		await this.appointmentsService.updateTask(taskKey, valueKey, $event);
	}

	get controllerTasks():Category[] {
		return Object.values(TaskControllerInstance);
	}

	get controller():TaskController {
		return TaskControllerInstance;
	}

	async completeCategory(category:Category) {
		const promises = []
		for(const item of category.items) {
			const key = `${category.id}.${item.id}`;
			const value = this.taskValues[key];
			if(!value) {
				this.taskValues[`${category.id}.${item.id}`] = true;
				promises.push(this.setValue(category.id, item.id, true));
			}
		}
		await Promise.all(promises);
	}

	protected async savePatient() {
		this.pageLoaderService.show("Saving patient...");
		try {
			await this.appointmentsService.savePatient();
			this.appointmentsService.infoUpdated().then();
			this.snackbarService.message("Patient information saved.")
		} catch(e) {
			this.snackbarService.error("Error saving patient information.")
		}

		this.pageLoaderService.close()
	}

}
